import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ApplicationStatus } from '../../types/jobPositionCandidate.types';
import { APPLICATION_STATUS_CONFIG } from '../../types/jobPositionCandidate.types';

interface ApplicationStatusBadgeProps {
  status: ApplicationStatus;
  className?: string;
}

const colorMap: Record<string, string> = {
  default: 'bg-gray-100 text-gray-800 border-gray-300',
  secondary: 'bg-slate-100 text-slate-700 border-slate-300',
  info: 'bg-blue-100 text-blue-800 border-blue-300',
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  success: 'bg-green-100 text-green-800 border-green-300',
  destructive: 'bg-red-100 text-red-800 border-red-300',
  muted: 'bg-neutral-100 text-neutral-600 border-neutral-300',
};

export function ApplicationStatusBadge({
  status,
  className,
}: ApplicationStatusBadgeProps): JSX.Element {
  const config = APPLICATION_STATUS_CONFIG[status];
  const colorClass = colorMap[config.color] ?? colorMap['default'];

  return (
    <Badge variant="outline" className={cn(colorClass, className)}>
      {config.label}
    </Badge>
  );
}
